export default __webpack_public_path__ + "static/media/dots_circle.e76da0a2.svg";